import { IconProps } from '@tamagui/helpers-icon';
import { HelpText } from '@unistocks/components/form/components/help-text';
import { Column, Row } from '@unistocks/components/layout/flex';
import { H4 } from '@unistocks/components/text/text';
import { PropsWithChildren } from 'react';
import { ViewProps } from 'tamagui';

export type FormSectionProps = PropsWithChildren<ViewProps> & {
  label: string;
  Icon?: React.ComponentType<IconProps>;
  helpText?: string;
};

export const FormSection: React.FC<FormSectionProps> = ({
  label,
  Icon,
  children,
  helpText,
  ...props
}) => {
  return (
    <Column {...props}>
      <Row justifyContent="flex-start" alignItems="center" mb={'$2'}>
        {Icon && <Icon />}
        <H4 color={'$headingFont'} flex={1}>
          {label}
        </H4>
        {helpText && <HelpText title={label} text={helpText} ml={'auto'} />}
      </Row>
      {children}
    </Column>
  );
};

FormSection.displayName = 'FormSection';
